import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileComponent } from './user-profile.component';
import { SharedModule } from '../../modules/shared.module';
import { DirectivesModule } from 'src/app/directives/directives.module';

@NgModule({
    declarations: [ UserProfileComponent ],
    imports: [ CommonModule, SharedModule, DirectivesModule ],
    exports: [ UserProfileComponent ],
    providers: [],
})
export class UserProfileModule {}